<template>
  <tbody>
    <template v-if="data.length">
      <template v-for="item in data">
        <tr>
          <td v-if="shouldRenderSelection">
            <multi-select :selection="selection" :row="item" />
          </td>
          <td v-for="col in columns" :class="col.tdClass" :style="Object.assign(textAlign(item,col),(typeof col.tdStyle === 'function'?col.tdStyle(item,item[col.field]&&typeof item[col.field] == 'object'?item[col.field][col.nested]:item[col.field]):col.tdStyle))" @click="typeof col.tdOnClick === 'function'?col.tdOnClick(item):()=>{return false;}">
            <!-- <td> component (tdComp) -->
            <component
              v-if="col.tdComp"
              :is="forDynCompIs(col.tdComp)"
              :row="item"
              :decimalLength="col.hasOwnProperty('floatLength')?col.floatLength:8"
              :field="col.nested||col.field"
              :value="item[col.field]&&typeof item[col.field] == 'object'?item[col.field][col.nested]:item[col.field]"
              :nested="item.__nested__"
              v-bind="$props">
            </component>
            <template v-else>
              {{col.field_prefix?col.field_prefix:''}}{{ item[col.field]&&typeof item[col.field] == 'object'?item[col.field][col.nested]:item[col.field]}}{{col.field_sufix?col.field_sufix:''}}
            </template>
          </td>
        </tr>
        <transition name="fade">
          <tr v-if="item.__nested__ && item.__nested__.visible">
            <td :colspan="colLen">
              <!-- nested component -->
              <component
                :is="forDynCompIs(item.__nested__.comp)"
                :row="item"
                :nested="item.__nested__"
                v-bind="$props">
              </component>
            </td>
          </tr>
        </transition>
      </template>
    </template>
    <tr v-else-if="!leftFixed && !rightFixed">
      <td :colspan="colLen" class="text-center text-muted">
        ( {{ $i18nForDatatable('No Data') }} )
      </td>
    </tr>
  </tbody>
</template>
<script>
import MultiSelect from './MultiSelect.vue'
import props from '../_mixins/props'
import shouldRenderSelection from '../_mixins/shouldRenderSelection'
import moment from 'moment'

export default {
  name: 'TableBody',
  components: { MultiSelect},
  mixins: [props, shouldRenderSelection],
  computed: {
    colLen () {
      return this.columns.length + !!this.selection
    },
  },
  methods: {
    textAlign(item,col) {
        if(col){
          var value = '';
          if(item[col.field] == 'object') value = item[col.field][col.nested];
          else value = item[col.field];
    
          if(isNaN(value)) return {'text-align':'left'};
        }
        return {'text-align':'right'}
    }
  }
}
</script>
<style>
.p1rem{
  padding: 1rem !important;
}
table tbody td{
  padding-right: 1.20rem !important;
  padding-left: 1.20rem !important;
}
td.leftfixed{
  position: sticky;
  left: 0;
  z-index: 1005 !important;
  background-color: #fff;
}
.table-striped tbody tr:nth-of-type(2n+1) td.leftfixed{
    background-color: #eee;
}
.table-striped tbody tr:nth-of-type(2n) td.leftfixed{
    background-color: #fff;
}
.eachThree td:nth-of-type(3n-2) {    
    border-right: 3px solid #c2cad1 !important;
}

</style>